import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { formatDistance, isAfter } from 'date-fns'

const Container = styled.div`
    display: flex;
    padding: 0.5rem;
    background-color: var(--secondary-color);
    border-radius: 5px;
    cursor: pointer;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Main = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const Icon = styled.div`
    width: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
`

const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 0.9rem;
`

const Subtitle = styled.div`
    font-size: 0.7rem;
    color: var(--secondary-accent-color);
    display: flex;
    justify-content: space-between;
`

const NotificationCard = props => {
    const {
        icon,
        title,
        subtitle,
        date,
        onSelect
    } = props;
    const dateText = formatDistance(new Date(date), new Date(), {addSuffix: true})

    return (
        <Container onClick={onSelect}>
            {/* <Icon>{icon}</Icon> */}
            <Main>
                <Header>
                    <Title>{title}</Title>
                </Header>
                <Subtitle>
                    <div>{subtitle}</div>
                    <div>{dateText}</div>
                </Subtitle>
            </Main>
        </Container>
    )
}

export default NotificationCard;

NotificationCard.propTypes = {

}